import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Primer Presentations uses the same `}<a parentName="p" {...{
        "href": "https://primer.style/css/support/color-system"
      }}>{`color system`}</a>{` created for our product. Color pairings for text, background, and highlighted/important information have been selected for optimal contrast. Refer to the following table for color pairings.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Background`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Text`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Highlight`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Footer`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Black`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`White`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Yellow-600`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Gray-600`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`White`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Black`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Blue-600`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Gray-600`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Gray-200`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Gray-900`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Blue-600`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Gray-600`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Yellow-300`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Gray-900`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Yellow-700`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Blue-600`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`White`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Blue-400`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      